import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      list: {
        flex: 'auto',
        flexShrink: 1,
        overflowX: 'hidden',
        overflowY: 'auto',
        color: '#595959',
      },
      item: {
        width: '100%',
        padding: '6px 22px',
        border: '1px solid transparent',
        '&:focus': {
          outline: 'none',
        },
      },
      itemIcon: {
        color: sicrediColor.primarySicredi,
        marginRight: theme.spacing(1),
      },
      itemText: {
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '"Nunito", sans-serif',
        fontSize: 13,
        fontWeight: 300,
        color: sicrediColor.secondarySicrediDarker,
        '& strong': {
          fontWeight: 700,
          marginRight: theme.spacing(1),
          textTransform: 'capitalize',
        },
        '& > p': {
          lineHeight: '24px',
          '& svg': {
            verticalAlign: 'middle',
            fontSize: 16,
          },
        },
      },
      itemResposta: {
        marginLeft: '27px',
      },
      itemAdmin: {
        backgroundColor: '#F3F7EF',
      },
      itemTextDestaque: {
        color: sicrediColor.primarySicredi,
      },
      hideName: {
        marginRight: '0 !important',
      },
      notify: {
        display: 'inline-block',
        width: 11,
        height: 11,
        borderRadius: '50%',
        backgroundColor: '#F44336',
        marginRight: theme.spacing(1),
      },
      itemDestque: {
        borderColor: 'rgba(63, 161, 16, 1)',
        backgroundColor: 'rgba(243, 247, 239, 1)',
        borderRadius: '8px',
        width: 'calc(100% - 32px)',
        margin: '0 16px',
        padding: 6,
        animation: '$destaque 5s ease-in-out forwards',
      },
      '@keyframes destaque': {
        '0%': {
          borderColor: 'rgba(63, 161, 16, 1)',
          backgroundColor: 'rgba(243, 247, 239, 1)',
        },
        '90%': {
          borderColor: 'rgba(63, 161, 16, 0)',
          backgroundColor: 'rgba(243, 247, 239, 0)',
        },
        '100%': {
          borderColor: 'rgba(63, 161, 16, 0)',
          backgroundColor: 'rgba(243, 247, 239, 0)',
        },
      },
    }),
  { name: 'Duvidas' }
);
